import { render, staticRenderFns } from "./fieldSetting.vue?vue&type=template&id=4d374bac&scoped=true"
import script from "./fieldSetting.vue?vue&type=script&lang=js"
export * from "./fieldSetting.vue?vue&type=script&lang=js"
import style0 from "./fieldSetting.vue?vue&type=style&index=0&id=4d374bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d374bac",
  null
  
)

export default component.exports